import { gql } from '@apollo/client';

export const lessonBigIdeasFragment = gql`
  fragment LessonBigIdeasFragment on Lesson {
    id
    bigIdeas {
      id
      description
    }
  }
`;

export const GET_BIG_IDEAS = gql`
  query GetBigIdeas {
    bigIdeas {
      id
      description
    }
  }
`;

export const ADD_BIG_IDEAS = gql`
  mutation AddBigIdeas($input: AddLessonBigIdeaInput!) {
    addLessonBigIdea(input: $input) {
      ...LessonBigIdeasFragment
    }
  }
  ${lessonBigIdeasFragment}
`;

export const DELETE_BIG_IDEAS = gql`
  mutation DeleteBigIdeas($input: DeleteLessonBigIdeaInput!) {
    deleteLessonBigIdea(input: $input) {
      ...LessonBigIdeasFragment
    }
  }
  ${lessonBigIdeasFragment}
`;
